// react
import React,{lazy,Suspense} from "react";
import { Navigation } from "react-minimal-side-navigation";
import "react-minimal-side-navigation/lib/ReactMinimalSideNavigation.css";
import { Redirect, Switch, Route } from "react-router-dom";
import {  useSelector } from "react-redux";
import {Badge} from 'reactstrap';
import BlockLoader from "../blocks/BlockLoader";


// pages
const AccountPageAddresses = lazy(()=> import("./AccountPageAddresses"));
const AccountPageDashboard = lazy(()=> import("./AccountPageDashboard"));
const AccountPageEditAddress = lazy(()=> import("./AccountPageEditAddress"));
const AccountPageOrders = lazy(()=> import("./AccountPageOrders"));
const AccountPagePassword = lazy(()=> import("./AccountPagePassword"));
const AccountPageProfile = lazy(()=> import("./AccountPageProfile"));
const BankApplication = lazy(()=> import("./bankRegistration/BankApplication"));
const AjmanApplication = lazy(()=> import("./ajmanRegistration/AjmanApplication"));

const DashboardAgent = lazy(()=> import("./DashboardAgent"));
const DashboardVentor = lazy(()=> import("./DashboardVentor"));
const AddPackage = lazy(()=> import("./vendor/AddPackage"));
const PackageList = lazy(()=> import("./vendor/PackageList"));
const UpdateKyc = lazy(()=> import("./UpdateKyc"));
const VendorProfile = lazy(()=> import("./vendor/VendorProfile"));
const TotalSales = lazy(()=> import("./TotalSales"));
const VendorOrdersList = lazy(()=> import("./vendor/VendorOrdersList"));
const VendorOrderDetails = lazy(()=> import("./vendor/VendorOrderDetails"));
const VendorNotifications = lazy(()=> import("./vendor/VendorNotifications"));
const CustomerNotifications = lazy(()=> import("./CustomerNotifications"));

// import AccountPageApplication from "./AccountPageApplication";
// import AccountPageInvestorVisaApplication from "./AccountPageInvestorVisaApplication";
// import AccountPageemploymentVisaApplication from "./AccountPageemploymentVisaApplication";
// import AccountPageOrderDetails from "./AccountPageOrderDetails";
// import EchannelApplication from "./echannel/EchannelApplication";
// import UBOApplication from "./uboRegistration/UBOApplication";


export default function AccountLayout(props) {

  const { match, location, history } = props;
  const auth = useSelector(state=>state.auth); 
  const count = auth.isLogin.user.msgcount;  

  const itemsVendor = [{
    title: "Dashboard",
    itemId: "/account/vendor-dashboard",                      
  },
  {
    title: "Orders / Services",
    itemId: "/account/vendor-orders",                      
  },
  {
    title: "Package List",
    itemId: "/account/packages",                      
  },
  {
    title: "Total Sale",
    itemId: "/account/sale",                      
  },
  {
    // title: `Notifications ${count>0 ? count : ""}` ,
    itemId: "/account/ven-notifications", 
    elemBefore: () => <>
      <span className="side-navigation-panel-select-option-text">Notifications </span>
      {count>0 && <Badge color="danger">{count}</Badge>} </>                  
  },
  {
    title: "Edit Profile",
    itemId: "/account/vendor-profile",                      
  },
  {
    title: "Addresses",
    itemId: "/account/addresses",                      
  },]

  const itemsAgent = [{
    title: "Dashboard",
    itemId: "/account/agent-dashboard",                      
  },
  {
    title: "Orders / Services",
    itemId: "/account/orders",                      
  },  
  // {
  //   title: "Update KYC",
  //   itemId: "/account/update-kyc",                      
  // },
  {
    title: "Edit Profile",
    itemId: "/account/profile",                      
  },
  {
    // title: `Notifications ${count>0 ? count : ""}` ,
    itemId: "/account/cus-notifications", 
    elemBefore: () => <>
      <span className="side-navigation-panel-select-option-text">Notifications </span>
      {count>0 && <Badge color="danger">{count}</Badge>} </>                  
  },
  {
    title: "Addresses",
    itemId: "/account/addresses",                      
  },]

  const itemsCustomer = [{
    title: "Dashboard",
    itemId: "/account/dashboard",                      
  },
  {
    title: "Orders / Services",
    itemId: "/account/orders",                      
  },  
  {
    title: "Edit Profile",
    itemId: "/account/profile",                      
  },
  {
    // title: `Notifications ${count>0 ? count : ""}` ,
    itemId: "/account/cus-notifications", 
    elemBefore: () => <>
      <span className="side-navigation-panel-select-option-text">Notifications </span>
      {count>0 && <Badge color="danger">{count}</Badge>} </>                  
  },
  {
    title: "Addresses",
    itemId: "/account/addresses",                      
  },]

  return (
    <React.Fragment>
      {/* <PageHeader header="Dashboard" breadcrumb={breadcrumb} /> */}

      <div className="block registernew">
        <div className="container">
          <div className="row">
            <div className="col-12 col-lg-3 d-flex">
              <div className="account-nav flex-grow-1">
                {/* <h4 className="account-nav__title">Dashboard</h4> */}

                <Navigation
                  activeItemId={location.pathname}
                  onSelect={({ itemId }) => {                    
                    history.push(itemId);
                  }}
                  items={auth.isLogin && auth.isLogin.user.role === 'vendor' ? itemsVendor : 
                  auth.isLogin.user.role === 'agent' ? itemsAgent : itemsCustomer}
                />

                {/* <ul>{links}</ul> */}
              </div>
            </div>
            <div className="col-12 col-lg-9 mt-4 mt-lg-0">
              <Suspense fallback={<BlockLoader/>}>
              <Switch>
                <Redirect exact from={match.path} to={`${match.path}/dashboard`} />
                <Route exact path={`${match.path}/dashboard`} component={AccountPageDashboard} />                
                <Route exact path={`${match.path}/vendor-dashboard`} component={DashboardVentor} />                
                <Route exact path={`${match.path}/vendor-orders`} component={VendorOrdersList} />                
                <Route exact path={`${match.path}/ven-notifications`} component={VendorNotifications} />                
                <Route exact path={`${match.path}/vendor-orders/:id`} component={VendorOrderDetails} />                
                <Route exact path={`${match.path}/agent-dashboard`} component={DashboardAgent} />                
                {/* <Route exact path={`${match.path}/application/:appId`} component={AccountPageApplication} /> */}
                {/* <Route exact path={`${match.path}/investorvisa/:vId`} component={AccountPageInvestorVisaApplication} /> */}
                {/* <Route exact path={`${match.path}/employmentvisa/:vId`} component={AccountPageemploymentVisaApplication} /> */}
                <Route exact path={`${match.path}/bank-application/:bankId`} component={BankApplication} />
                <Route exact path={`${match.path}/ajman-application/:vId`} component={AjmanApplication} />
                {/* <Route exact path={`${match.path}/e-channel/:vId`} component={EchannelApplication} /> */}
                {/* <Route exact path={`${match.path}/ubo-register/:id`} component={UBOApplication} /> */}
                
                <Route exact path={`${match.path}/cus-notifications`} component={CustomerNotifications} />     
                <Route exact path={`${match.path}/profile`} component={AccountPageProfile} />
                <Route exact path={`${match.path}/orders`} component={AccountPageOrders} />
                {/* <Route exact path={`${match.path}/orders/:id`} component={AccountPageOrderDetails} /> */}
                <Route exact path={`${match.path}/addresses`} component={AccountPageAddresses} />
                <Route exact path={`${match.path}/addresses/:id`} component={AccountPageEditAddress} />
                <Route exact path={`${match.path}/password`} component={AccountPagePassword} />

                <Route exact path={`${match.path}/add-package`} component={AddPackage} />
                <Route exact path={`${match.path}/packages`} component={PackageList} />
                <Route exact path={`${match.path}/update-kyc`} component={UpdateKyc} />
                <Route exact path={`${match.path}/vendor-profile`} component={VendorProfile} />
                <Route exact path={`${match.path}/sale`} component={TotalSales} />
              </Switch>
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
